// extracted by mini-css-extract-plugin
module.exports = {"srOnly":"srOnly_srOnly__10zJQ"};